import { useDispatch } from 'react-redux';
import { settingsActions } from 'Containers/Settings/store';
import clsx from 'clsx';
import useWindowSize from 'utils/useWindowSize';
import { useTranslation } from 'react-i18next';
import { sendMessageToApp } from 'utils/exsternalCall';
import { ExternalLink, FileText, ScrollText } from 'lucide-react';
import styles from './index.module.scss';

const TERMS_URL =
  'https://general-store-s3.s3.eu-south-1.amazonaws.com/zetabarber/nuovi+Termini+e+condizioni+generali+di+servizio.html';

const TermsModal = () => {
  const { t } = useTranslation();
  const { isMobile } = useWindowSize();
  const dispatch = useDispatch();
  const fromApp = !!localStorage.getItem('fromApp');

  const openTerms = () => {
    if (!fromApp) window.open(TERMS_URL, '_blank', 'noopener,noreferrer');
    else sendMessageToApp('app:url', { url: TERMS_URL });
  };

  const acceptTerms = () => {
    dispatch(settingsActions.ACCEPT_TERMS.REQUEST());
  };

  return (
    <div className={clsx(styles.container, { [styles.container_mbl]: isMobile })}>
      <div className={styles.hero}>
        <span className={styles.icon_wrap} aria-hidden>
          <ScrollText size={28} strokeWidth={2.1} />
        </span>
        <span className={styles.eyebrow}>{t('modals.terms.eyebrow')}</span>
        <h2 className={styles.title}>{t('modals.terms.title')}</h2>
        <p className={styles.body}>
          {t('modals.terms.text1')}{' '}
          <button type="button" className={styles.inline_link} onClick={openTerms}>
            {t('modals.terms.link')}
          </button>{' '}
          {t('modals.terms.text2')}{' '}
          <button type="button" className={styles.inline_link} onClick={openTerms}>
            {t('modals.terms.here')}
          </button>
          .
        </p>
      </div>

      <button type="button" className={styles.link_card} onClick={openTerms}>
        <span className={styles.link_card_icon} aria-hidden>
          <FileText size={18} strokeWidth={2.2} />
        </span>
        <span className={styles.link_card_copy}>
          <strong>{t('modals.terms.readCta')}</strong>
          <span>{t('modals.terms.readHint')}</span>
        </span>
        <ExternalLink size={16} strokeWidth={2.2} className={styles.link_card_arrow} aria-hidden />
      </button>

      <p className={styles.confirm_note}>{t('modals.terms.confirm')}</p>

      <div className={styles.footer}>
        <button type="button" className={styles.accept_button} onClick={acceptTerms}>
          {t('modals.terms.accept')}
        </button>
      </div>
    </div>
  );
};

export default TermsModal;
